<template>
  <div>
    <BaseListPage
        :name="name"
        :base-query="baseQuery"
        :store-path="storePath"
        :response-path="responsePath"
        :save-key="saveKey"
        :table-set-list="tableSetList"
        :table-data-list="sortedList"
        :title="title"
        icon="customer"
        title-class="customer-header"
        table-class="row-clickable-table"
        @row-click="onRowClick" />
  </div>
</template>

<script>
import _ from 'lodash'

import { mapState, mapGetters } from 'vuex'
import * as define from '@/define'
import * as query from '@/queries/customer'
import x from '@/components/mixins/mixin'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseListPage from '@/components/organisms/BaseListPage'
import customer from '@/store/pages/customer'

const title = '顧客一覧'

export default {
  name: 'CustomerList',
  title: title,
  components: {
    BaseListPage
  },
  mixins: [x],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  computed: {
    ...mapState({
      tableSetList: (state) => state.Customer.tableSetList
    }),
    ...mapGetters({
      getSortedList: 'sortedList'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    title () {
      return title
    },
    name () {
      return 'customerList'
    },
    storePath () {
      return 'Customer'
    },
    saveKey () {
      return 'customerCondition'
    },
    responsePath () {
      return 'data.customers.edges'
    },
    linkKey () {
      return 'node.uuid'
    },
    returnPath () {
      return '/customer'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_CUSTOMER_LIST
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      return [
        {
          type: 'String', label: '顧客グループ', path: ['node.customerGroup.code', 'node.customerGroup.name'], colsep: '：',
          sortable: 'custom', name: 'node.customerGroup.code',
          funcId: define.PermissionKeys.Customer.List.CUSTOMER_GROUP
        },
        {
          type: 'String', label: '代表顧客番号', path: (row) => row.node.nos[0].no, elementType: ELEMENT_TYPE.FUNCTION,
          sortable: 'custom', name: 'node.nos[0].no',
          funcId: define.PermissionKeys.Customer.List.CUSTOMER_MAIN_NUMBER
        },
        {
          type: 'String', label: '顧客番号', elementType: ELEMENT_TYPE.FUNCTION,
          path: (row) => {
            return _.chain(row.node.nos)
              .map('no')
              // .drop()
              .join(', ')
              .value()
          },
          funcId: define.PermissionKeys.Customer.List.CUSTOMER_MAIN_NUMBER
        },
        { type: 'String', label: '氏名', path: ['node.personalInfo.lastName', 'node.personalInfo.firstName'],
          funcId: define.PermissionKeys.Customer.List.NAME },
        { type: 'String', label: 'メールアドレス', path: 'node.personalInfo.email', sortable: 'custom',
          funcId: define.PermissionKeys.Customer.List.MAILADDRESS }
      ]
    }
  },
  async created () {
    this.$loadingService.show()
    try {
      this.$store.dispatch({
        type: 'set',
        states: {
          'Customer/tableSetList': this._tableSetList
        }
      })

      const groupOptions = _.uniqBy(_.map(this.$store.state.sites, site => {
        return {
          code: site.customerGroup.code,
          name: site.customerGroup.code + ': ' + site.customerGroup.name
        }
      }), 'code')

      this.$store.dispatch({
        type: 'set',
        states: {
          'Customer/searchConditions/customerGroupCodes/options': groupOptions
        }
      })

      // rank選択肢がないとき、マスタから取得
      await customer.getCustomerRank()
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  methods: {
    onRowClick (row, column, event) {
      const id = _.get(row, this.linkKey)
      const index = this.$_mixin_findIndex(this.sortedList, { [this.linkKey]: id })
      this.$_mixin_onLinkClick(index, this.storePath)
      this.$router.push({ path: `/customer/${id}` })
    }
  }
}
</script>
